import { INavLink, INavLinkGroup, INavStyles, Nav } from "@fluentui/react";
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import COLORES from "../../../utils/theme/colores";

export const ConfiguracionMenuIperc = () => {
  const navigate = useNavigate();
  const outletStyle: Object = {
    maxHeight: "calc(100vh - 4rem)",
    width: "calc(100% - 230px)",
  };
  const navLinkGroups: INavLinkGroup[] = [
    {
      name: "Configuraciones",
      links: [
        {
          key: "areas",
          name: "Áreas",
          url: "areas",
          icon: "EntitlementRedemption",
        },
         {
          key: "equipos",
          name: "Equipos",
          url: "equipos",
          icon: "EntitlementRedemption",
        },
        {
          key: "actividades",
          name: "Actividades",
          url: "actividades",
          icon: "EntitlementRedemption",
        },
      ],
    },
  ];
  const navStyles: Partial<INavStyles> = {
    root: {
      width: "230px",
      height: "calc(100vh - 3rem)",
      maxwidth: "300px",
      boxSizing: "border-box",
      border: "1px solid #eee",
      overflowY: "auto",
      cursor: "pointer",
      backgroundColor: COLORES.Bases.BackgroundNavOutlook,
    },
    groupContent: {
      marginBottom: "15px",
      padding: "0 10px 0 0",
    },
    link: {
      paddingLeft: "25px",
      height: "25px",
      borderRadius: "10xp",
      font: "inherit",
      margin: 5,
    },
    chevronButton: {
      fontSize: "14px",
      height: "35px",
      borderRadius: "10xp",
    },
  };
  const _clickNavigate = (
    ev?: React.MouseEvent<HTMLElement>,
    item?: INavLink
  ) => {
    if (ev) {
      ev.preventDefault();
      if (item) {
        navigate(item.url);
      }
    }
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            maxHeight: "calc(100vh - 3rem)",
            overflowY: "scroll",
            width: "100%",
          }}
        >
          <div>
            <Nav
              styles={navStyles}
              groups={navLinkGroups}
              onLinkClick={_clickNavigate}
            />
          </div>
          <div style={outletStyle}>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};
